import calendarIcon from '@/icons/calendar-outline-icon.svg';
import noContractsIcon from '@/icons/no-contracts-icon.svg';
import {getProductSelection} from '@/product/product-selection';
import {calculatePricePerLoad} from '@/product/product-selection/calculate-price-per-load';
import formatCurrency from '@/utilities/format-currency';

const subscriptionSummaryLabel = 'Subscription Summary';
const perLoadLabel = 'per load';
const noContractsLabel = 'No Contracts, Cancel Anytime';

export default function SubscriptionSummary({
  currency = 'USD',
  locale,
}: SubscriptionSummaryProps) {
  const {selectedVariant, selectedPlan} = getProductSelection();
  const pricePerLoad = selectedVariant
    ? calculatePricePerLoad(selectedVariant, selectedPlan)
    : 0;

  return (
    <div className="flex flex-col gap-y-3">
      <div className="grid-cols-grow-max-grow grid items-center gap-x-5">
        <hr className="w-full bg-deep-ocean-blue/70" />
        <span className="font-semibold">{subscriptionSummaryLabel}</span>
        <hr className="w-full bg-deep-ocean-blue/70" />
      </div>
      <div className="grid grid-cols-3 justify-items-center gap-x-6 gap-y-2 text-center text-sm">
        <img src={noContractsIcon} alt="No Contracts Icon" className="size-8" />
        <img
          src={calendarIcon}
          alt="Calendar Outline Icon"
          className="size-8"
        />
        <span className="text-2xl">
          {pricePerLoad ? formatCurrency(pricePerLoad, currency, locale) : null}
        </span>
        <span>{noContractsLabel}</span>
        <span>{selectedPlan?.external_plan_name}</span>
        <span>{pricePerLoad ? perLoadLabel : ''}</span>
      </div>
    </div>
  );
}

export type SubscriptionSummaryProps = {
  currency?: string;
  locale?: string;
};
